/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CouponPayVo
 */
export interface CouponPayVo {
    /**
     * 账单ID
     * @type {number}
     * @memberof CouponPayVo
     */
    billId: number;
    /**
     * 优惠券ID
     * @type {number}
     * @memberof CouponPayVo
     */
    couponId: number;
    /**
     * 数量，默认为1
     * @type {number}
     * @memberof CouponPayVo
     */
    quantity?: number;
    /**
     * 优惠券金额
     * @type {number}
     * @memberof CouponPayVo
     */
    amount?: number;
}

/**
 * Check if a given object implements the CouponPayVo interface.
 */
export function instanceOfCouponPayVo(value: object): value is CouponPayVo {
    if (!('billId' in value) || value['billId'] === undefined) return false;
    if (!('couponId' in value) || value['couponId'] === undefined) return false;
    return true;
}

export function CouponPayVoFromJSON(json: any): CouponPayVo {
    return CouponPayVoFromJSONTyped(json, false);
}

export function CouponPayVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponPayVo {
    if (json == null) {
        return json;
    }
    return {
        
        'billId': json['billId'],
        'couponId': json['couponId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function CouponPayVoToJSON(json: any): CouponPayVo {
    return CouponPayVoToJSONTyped(json, false);
}

export function CouponPayVoToJSONTyped(value?: CouponPayVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billId': value['billId'],
        'couponId': value['couponId'],
        'quantity': value['quantity'],
        'amount': value['amount'],
    };
}

